export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "pl": {
        "No records found": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nie znaleziono danych"])}
      }
    }
  })
}
